export const cibMarketo = ["32 32","<path d='M21.527 0v32l8.181-6.516v-21.036zM17.724 25.011l-6.584 2.875v-25.104l6.584 1.948zM2.297 24.271l5.036-1.328v-16.025l-5.016-0.808z'></path>"]


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/js/brand/cib-marketo.js
// module id = null
// module chunks = 